const StrateSliderTemoignages = {
    
    init() {
        const strate = $('#strate-slider-temoignages');
        
        if (strate) {
            const sliderItem = $('#strate-slider-temoignages .inner_content_wrapper .bottom_slider .slider .slide_temoignage');
            const leftBtn = $('#strate-slider-temoignages .inner_content_wrapper .top_slider .col_top_slider_right .left');
            const rightBtn = $('#strate-slider-temoignages .inner_content_wrapper .top_slider .col_top_slider_right .right');
    
            if (sliderItem.length > 1) {
                StrateSliderTemoignages.build();

                leftBtn.click(
                    function () {
                        $('#strate-slider-temoignages .inner_content_wrapper .bottom_slider .slider').trigger('prev.owl.carousel');
                        return false;
                    }
                );
                rightBtn.click(
                    function () {
                        $('#strate-slider-temoignages .inner_content_wrapper .bottom_slider .slider').trigger('next.owl.carousel');
                        return false;
                    }
                );
            } else {
                leftBtn.addClass('no_slider');
                rightBtn.addClass('no_slider');
            }
        }
    },

    build() {
        const sliderWrapper = $('#strate-slider-temoignages .inner_content_wrapper .bottom_slider .slider').addClass('owl-carousel');

        sliderWrapper.owlCarousel(
            {
                loop: true,
                margin: 20,
                items: 1,
                center: true,
                nav: false,
                dots: true,
                stagePadding: 0,
                autoWidth: false,
                responsive: {
                    1024: {
                        loop: true,
                        margin: 35,
                        items: 2,
                        center: false,
                        nav: false,
                        dots: false,
                        stagePadding: 0,
                        autoWidth: true,
                    },
                },
            }
        );
    },
};

export default StrateSliderTemoignages;
